import { formatCurrencyNumber, insertIf } from "@finway-group/shared/lib/utils"
import { Avatar, Button, TableColumnType, Tooltip } from "antd"
import ExpenseTagColumn from "Components/expenseTagColumn"
import React from "react"
import AuthzService from "Shared/services/authz.service"
import { IsServiceIcon } from "../icons/IsServiceIcon"
import { ShoppingBagIcon } from "../icons/ShoppingBagIcon"
import { ProcurementTableColumn } from "../types/PurchaseOrder.interfaces"
import { GenerateProcurementColumnsProps } from "../types/utils/helper.util"

enum ProcurementColumns {
    NAME = "name",
    TAGS = "tags",
    ACTION = "action",
    AMOUNT = "amount",
}

export const procurementColumnMapper: Partial<Record<keyof ProcurementTableColumn, string>> = {
    [ProcurementColumns.NAME]: "purchaseOrderNumber",
    [ProcurementColumns.TAGS]: "tags",
    [ProcurementColumns.AMOUNT]: "totalGrossPrice",
}

export const GenerateProcurementColumns = ({ updateRecord, t }: GenerateProcurementColumnsProps<ProcurementTableColumn>): Array<TableColumnType<ProcurementTableColumn>> => [
    {
        title: t("purchaseOrders:columns.name"),
        dataIndex: ProcurementColumns.NAME,
        key: ProcurementColumns.NAME,
        width: 250,
        render: (_, record: ProcurementTableColumn) => (
            <div className="flex items-center gap-8 overflow-hidden">
                <Avatar
                    src={"#"}
                    icon={record.isService ? <IsServiceIcon /> : <ShoppingBagIcon />}
                    size={38}
                    style={{
                        background: "rgba(111, 186, 255, 0.10)",
                    }}
                    className="flex-shrink-0 bg-[rgba(111,186,255,0.10)] flex rounded-full border-none justify-center items-center"
                />
                <div className="flex-1 overflow-hidden">
                    <Tooltip title={record.purchaseOrderNumber}>
                        <div className="font-bold text-15 text-[#181c32] overflow-hidden text-ellipsis whitespace-no-wrap">{record.purchaseOrderNumber}</div>
                    </Tooltip>
                    <Tooltip title={record.description}>
                        <div className="text-15 text-[#6B7280] overflow-hidden text-ellipsis whitespace-no-wrap font-normal">{record.description}</div>
                    </Tooltip>
                </div>
            </div>
        ),
        sorter: true,
    },
    {
        title: t("label:tags"),
        dataIndex: ProcurementColumns.TAGS,
        key: ProcurementColumns.TAGS,
        width: 100,
        sorter: true,
        ellipsis: true,
        render: (_, record) => <ExpenseTagColumn expenseTagIds={record.tags} />,
    },
    {
        title: t("purchaseOrders:columns.amount"),
        dataIndex: ProcurementColumns.AMOUNT,
        key: ProcurementColumns.AMOUNT,
        width: 100,
        ellipsis: true,
        sorter: true,
        render: (_, record: ProcurementTableColumn) => (
            <span className="font-bold text-15">{formatCurrencyNumber({ value: record.totalGrossPrice, currency: record.currency })}</span>
        ),
    },
    ...insertIf<TableColumnType<ProcurementTableColumn>>(AuthzService.isUserProcurementApprover(), {
        title: t("purchaseOrders:columns.action"),
        key: ProcurementColumns.ACTION,
        width: 150,
        render: (_, record) => (
            <Button
                type="primary"
                onClick={(e) => {
                    e.stopPropagation()
                    updateRecord(record)
                }}
            >
                {t("label:release_order")}
            </Button>
        ),
    }),
]
